import cx from 'classnames';
import {ReactNode} from 'react';
import {Typography} from '~library/atoms/Typography';
import {useIsLargishAndUp} from '~library/hooks/useMatchQuery';

import './Step.sass';

type StepProps = {
  children: ReactNode;
  header: ReactNode;
  footer?: ReactNode;
  description?: string;
  headerClassName?: string;
  contentClassName?: string;
  footerClassName?: string;
};

export const Step = ({
  header,
  children,
  description,
  footer,
  headerClassName,
  contentClassName,
  footerClassName,
}: StepProps) => {
  const isLargishAndUp = useIsLargishAndUp();

  return (
    <div className="rsvp-step">
      <div className={cx('rsvp-step__header', headerClassName)}>{header}</div>

      <div className={cx('rsvp-step__content', contentClassName)}>
        {description && (
          <Typography
            variant={isLargishAndUp ? 'paragraph3' : 'paragraph2'}
            color={isLargishAndUp ? 'pebble' : 'charcoal'}
          >
            {description}
          </Typography>
        )}
        {children}
      </div>

      {footer && <div className={cx('rsvp-step__footer', footerClassName)}>{footer}</div>}
    </div>
  );
};
